import { gql } from "@apollo/client";
import { Database } from "@nozbe/watermelondb";
import { LayoutNodeFilterDeepNestingFragment } from "@towersystems/roam-common/lib/generated-graphql-fragment";
import {
  LayoutNodeDeepNestingFragment,
  LayoutNodeLinkDeepNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import {
  LayoutNode as LayoutNodeEntity,
  LayoutNodeInput,
} from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import { default as LayoutNodeModel } from "../../data/model/LayoutNode";
import { AsyncLayoutActionDefinition } from "../types";

export const updateLayoutNodeMutation = gql`
  ${LayoutNodeFilterDeepNestingFragment}
  ${LayoutNodeLinkDeepNestingFragment}
  ${LayoutNodeDeepNestingFragment}
  mutation UpdateLayoutNode($input: LayoutNodeInput!) {
    updateLayoutNode(input: $input) {
      ...LayoutNodeDeepNesting
    }
  }
`;

export const updateLayoutKeyDefinition = new AsyncLayoutActionDefinition<
  LayoutNodeEntity,
  LayoutNodeModel,
  (
    database: Database,
    id: string,
    layoutKeyInput: LayoutNodeInput
  ) => Promise<LayoutNodeModel>,
  (layoutKey: any) => Promise<LayoutNodeEntity>
>({
  localAction: async (
    database: Database,
    id: string,
    layoutKeyInput: LayoutNodeInput
  ) => {
    return database.write(async () => {
      return database.collections
        .get<LayoutNodeModel>("layout_nodes")
        .find(id)
        .then((record) => {
          return record.update((layoutNode) => {
            layoutNode.layoutId = layoutKeyInput.layoutId || null;
            layoutNode.label = layoutKeyInput.label || null;
            layoutNode.color = layoutKeyInput.color;
            layoutNode.showImage = layoutKeyInput.showImage || null;
            layoutNode.type = layoutKeyInput.type || null;
            layoutNode.position = layoutKeyInput.position || 0;
            layoutNode.action = layoutKeyInput.action || null;
            layoutNode.link = layoutKeyInput.link || null;
            layoutNode.filter = layoutKeyInput.filter || null;
          });
        });
    });
  },
  remoteAction: async (layoutKeyInput: LayoutNodeInput) => {
    return client
      .mutate({
        variables: { input: layoutKeyInput },
        mutation: updateLayoutNodeMutation,
      })
      .then((result) => {
        return result.data?.updateLayoutNode;
      });
  },
});
